import React, { useState } from 'react';

// import { Link } from 'react-router-dom';

import styles from './home.module.css';

const linkProps = {
  rel: 'noreferrer noopener',
  target: '_blank',
};

const iLikeOptions = [
  {
    key: 'maps',
    label: 'maps',
    // imgPath: 'img/i-like/google-maps@2x.jpg',
    imgPath: 'img/i-like/google-maps-new@2x.png',
    url: 'https://maps.google.com/',
    caption: 'maps.google.com',
  },
  {
    key: 'icons',
    label: 'icons',
    imgPath: 'img/i-like/react-icons@2x.png',
    url: 'https://react-icons.github.io/react-icons/',
    caption: 'react-icons.github.io/react-icons',
  },
  {
    key: 'type',
    label: 'type',
    imgPath: 'img/i-like/google-fonts@2x.jpg',
    url: 'https://fonts.google.com/',
    caption: 'fonts.google.com',
  },
  {
    key: 'music',
    label: 'music',
    imgPath: 'img/i-like/spotify@2x.jpg',
    url: 'https://open.spotify.com/artist/1TIbqr0x8HoKzKBNtNN8wf?si=mIqfy4Q_R9-yw1s-1LmcrA',
    caption: 'spotify.com',
  },
  {
    key: 'code',
    label: 'code',
    imgPath: 'img/i-like/code@2x.jpg',
    url: 'https://code.visualstudio.com/',
    caption: 'code.visualstudio.com',
  },
];

const Home = (props) => {

  const [ilike, setIlike] = useState(null);

  const ilikeData = iLikeOptions.find(option => option.key === ilike);
  const ilikeImgs = iLikeOptions.map(option => {
    const img = option?.imgPath && <img src={option.imgPath} alt='' />
    const imgEl = option?.url ? <a href={option?.url} {...linkProps}>{img}</a> : img;
    const isActive = option.key === ilike;
    return <div key={option.key} className={[styles.image, isActive && styles.show].filter(Boolean).join(' ')}>{imgEl}</div>;
  });
  
  return (
    <section className={styles.columns}>
      <div className={styles.col}>
        <h2>Hello &mdash;</h2>
        <p>My name is Jacob Winkelman. I am a designer, developer, and critical thinker living in Los Angeles. I like {iLikeOptions.map((option, index) => {
          let renderAfter = ', ';
          if (iLikeOptions.length) {
            if (index === iLikeOptions.length - 1) renderAfter = null;
            if (index === iLikeOptions.length - 2) renderAfter = ', and ';
          };

          const showImage = () => setIlike(option.key);

          return (
            <React.Fragment key={option.key}>
              <span
                className={styles.ilike}
                onMouseEnter={showImage}
                onClick={showImage}
              >
                {option.label}
              </span>
              {renderAfter}
            </React.Fragment>
          );
        })}.</p>
        <p>I am happiest when I am able to apply my conceptual thinking, technical knowledge, attention to detail, and organizational skills to work in development, information architecture, and user interface design.</p>
        <p>I'm currently creative lead at <a href='https://grablabs.com' target='_blank' rel='noopener noreferrer'>Grab Labs</a> where I'm designing and building a lot of {/* <Link to='/twitch'>Twitch Extensions</Link> */}<a href='https://grablabs.com/twitch'  target='_blank' rel='noopener noreferrer'>Twitch Extensions</a> and exploring interactivity over live-streaming.</p>
      </div>
      <div className={styles.col}>
        <div className={styles.images}>
          {ilikeImgs}
          {Boolean(ilikeData?.imgPath) || <img src='img/i-like/placeholder@2x.png' alt='' />}

        </div>
        <div className={styles.caption}>{ilikeData?.label} {ilikeData?.caption ? `// ${ilikeData?.caption}` : '–'}</div>
      </div>
    </section>
  )
}

export default Home;
